// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__PUtfh","notes":"Notes_notes__McE37"};